import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import { Point } from '../../context-discovery-services/models/point.model';
import { AssetStatus } from '../../context-discovery-services/constants/asset-status.const';

@Component({
  selector: 'adminapp-all-points',
  templateUrl: './all-points.component.html',
  styleUrls: ['./all-points.component.scss']
})
export class AllPointsComponent implements AfterViewInit, OnInit {

  @Input()
  public set pointsList(listOfPoints: Array<Point>) {
    if (!this.pointsGrid || !listOfPoints) {
      return;
    }

    this.pointsGrid.items = listOfPoints.map(point => {
      point['assetName'] = point.asset ? point.asset.label : '';
      point['assetType'] = (point.asset && point.asset.equipment) ? point.asset.equipment.label : '';
      point['status'] = point.asset ? point.asset.confirmed ? AssetStatus.CONFIRMED : AssetStatus.UNCONFIRMED : '';
      point['locationLabel'] = point.location ? point.location.label : '';

      return point;
    });

    setTimeout(function () {
      this.pointsGrid.refreshData();
    }.bind(this), 10);
  }
  pointsGrid: any;
  pointsGridSelectAll: any;
  isRefreshColumnsCalled: boolean;

  @Input()
  isLoading = false;

  constructor() { }

  ngAfterViewInit(): void {
    this.pointsGrid = document.getElementById('points-grid');
    if (this.pointsGrid) {
      this.pointsGridSelectAll = this.pointsGrid._selectAllCheckbox;
      this.pointsGrid.columns = this.getColumns();
    }
  }

  refreshColumns(): void {
    setTimeout(() => {
      this.isRefreshColumnsCalled = true;
      this.pointsGrid.refreshColumns();
    }, 500);
  }

  ngOnInit(): void {
  }

  getEnumsFromPoint(point: Point) {
    const allConceptLabels = [];
    if (point.bindings) {
      point.bindings.forEach(
        function (propBinding) {
          const conceptMapKeys = Object.keys(propBinding.conceptMap);
          if (conceptMapKeys) {
            conceptMapKeys.forEach(
              function (conceptMapKey) {
                allConceptLabels.push(propBinding.conceptMap[conceptMapKey]);
              }
            );
          }
        }
      );
    }
    return allConceptLabels.filter((it, i, ar) => ar.indexOf(it) === i).join(', ');
  }

  getSelectedItems() {
    return this.pointsGrid ? this.pointsGrid.selectedItems : [];
  }

  unselectAll() {
    this.pointsGrid.selectItems(this.pointsGrid.items, false);
  }

  getColumns() {
    return [
      { id: 'SelectAll', width: '50px' },
      { id: 'label', label: 'Label', isSortable: true, isResizable: true },
      { id: 'assetName', label: 'Asset Name', isSortable: true, isResizable: true },
      { id: 'assetType', label: 'Asset Type', isSortable: true, isResizable: true },
      { id: 'status', label: 'Status', isSortable: true, isResizable: true },
      { id: 'comment', label: 'Description', isSortable: true, isResizable: true },
      { id: 'locationLabel', label: 'Location', isSortable: true, isResizable: true },
      { id: 'unitLabel', label: 'Unit Label', isSortable: true, isResizable: true },
      { id: 'conceptLabels', label: 'Enum Labels', isResizable: true }
    ];
  }
}
